<template>
  <div class="filter-container">
    <el-row>
      <el-col :xs="24" :sm="12" :md="12" :lg="6" :xl="6">
        <el-input ref="searchFilter"
                  v-model="searchText"
                  :placeholder="$t('common.search')"
                  prefix-icon="el-icon-search"
                  focus
                  autofocus
                  @input="debouncedSearchFunction"
                  @keyup.esc="onSearchTextEscape">
          <el-button
            slot="append"
            icon="el-icon-search"
          />
        </el-input>
      </el-col>
      <div style="flex: auto;">
        <el-button type="primary"
                   icon="el-icon-plus"
                   circle
                   style="float: right;"
                   @click="onAddBtnClick" />
      </div>
    </el-row>
  </div>
</template>

<script>
import debounce from 'lodash/debounce'

export default {
  name: 'FreeSearchFilter',
  data () {
    return {
      searchText: '',
      debouncedSearchFunction: null
    }
  },
  created () {
    this.debouncedSearchFunction = debounce(this.sendSearchEvent, 300)
  },
  methods: {
    onSearchTextEscape: function () {
      this.searchText = ''
      this.sendSearchEvent()
    },
    sendSearchEvent: function () {
      this.$emit('search', this.searchText)
    },
    onAddBtnClick: function () {
      this.$emit('addEntity')
    }
  }
}
</script>

<style scoped>
.filter-container {
  height: 66px;
}
</style>



// WEBPACK FOOTER //
// src/components/common/FreeSearchFilter.vue